/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { memo, useEffect } from 'react';
import css from './SeoLandingPage.css';
import isEqual from 'lodash/isEqual';
import { useHistory } from 'react-router';
import { TOP_BRANDS } from './seoCategoriesArrays';

const SeoLandingRentOtherBrands = memo(
  ({ selectedValues, setSelectedValues, brandCategory }) => {
    const history = useHistory();
    useEffect(() => {
      const getDefaultKey =
        TOP_BRANDS.values &&
        TOP_BRANDS.values.length > 0 &&
        TOP_BRANDS.values.filter(item => item.label === brandCategory);
      setSelectedValues(getDefaultKey[0]);
    }, []);
    const redirectToDifferentLocation = (brand, locationName) => {
      setSelectedValues(brand);
      history.push(locationName);
      history.go(0);
    };
    return (
      <div className={css.rentFromOtherBrands}>
        <div className={css.rentFromOtherBrandsContainer}>
          <div className={css.rentFromOtherBrandsTitle}>
            <span>Rent cars from other popular brands</span>
            <p>
              Owing to the fact that all cars on Drive lah are owned by real people, we are able to
              offer a much more diverse brands of cars and that too at highly economical price
              points. Rent cars from popular brands on Drive lah today.
            </p>
          </div>
          <div className={css.rentFromOtherBrandsListing}>
            <ul className={css.listings}>
              {TOP_BRANDS.values.map(carBrand => {
                if (selectedValues && selectedValues.key !== carBrand.key) {
                  return (
                    <li
                      key={carBrand.key}
                      className={css.listingsItem}
                      onClick={() =>
                        redirectToDifferentLocation(carBrand, TOP_BRANDS.generateRoute(carBrand.key))
                      }
                    >
                      <div className={css.listingsItemContent}>{carBrand.label}</div>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  },
  (prev, next) => isEqual(prev, next)
);

export default SeoLandingRentOtherBrands;
